import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const scrollTo = (id, type) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    if (type) {
        window.dispatchEvent(new CustomEvent("set-inquiry-type", { detail: type }));
    }
};

const BG =
    "https://images.unsplash.com/photo-1632852576480-c10a8e19496a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwQ2FyaWJiZWFuJTIwZm9vZCUyMHBsYXRpbmclMjBkYXJrfGVufDB8fHx8MTc3OTY3MjQ0NXww&ixlib=rb-4.1.0&q=85";

export default function FinalCTA() {
    return (
        <section
            data-testid="final-cta-section"
            className="relative overflow-hidden bg-burgundy"
            aria-label="Bring The Flavor"
        >
            <div className="absolute inset-0 z-0">
                <img
                    src={BG}
                    alt=""
                    aria-hidden
                    className="absolute inset-0 w-full h-full object-cover opacity-30"
                />
                <div className="absolute inset-0 bg-burgundy/80" />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 via-burgundy/70 to-charcoal/40" />
            </div>

            <div className="relative z-10 empire-container py-28 md:py-40 text-center">
                <motion.p
                    initial={{ opacity: 0, y: 14 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="empire-eyebrow !text-gold"
                >
                    Catering & Private Events
                </motion.p>
                <motion.h2
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
                    data-testid="final-cta-heading"
                    className="mt-6 mx-auto max-w-4xl font-serif text-cream text-[2.4rem] md:text-[4rem] lg:text-[5rem] leading-[1.04] tracking-[-0.01em]"
                >
                    Bring the flavor of the<br />
                    <span className="italic text-gold">Caribbean</span> to your next gathering.
                </motion.h2>
                <motion.p
                    initial={{ opacity: 0, y: 14 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.3 }}
                    className="mt-6 max-w-xl mx-auto text-cream/80 text-base font-light"
                >
                    From weddings and corporate gatherings to intimate dinners,
                    let&rsquo;s build something around the night you&rsquo;re planning.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 18 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.45 }}
                    className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4"
                >
                    <button
                        type="button"
                        onClick={() => scrollTo("catering-inquiry", "catering")}
                        data-testid="final-cta-book-catering"
                        className="inline-flex items-center justify-center gap-2 bg-cream text-charcoal px-8 py-4 text-[12px] uppercase tracking-[0.22em] font-medium hover:bg-gold transition-colors duration-300"
                    >
                        Book Catering
                        <ArrowRight size={14} />
                    </button>
                    <button
                        type="button"
                        onClick={() => scrollTo("catering-inquiry", "private_event")}
                        data-testid="final-cta-reserve-event"
                        className="inline-flex items-center justify-center gap-2 border border-cream/70 text-cream px-8 py-4 text-[12px] uppercase tracking-[0.22em] font-medium hover:bg-cream hover:text-charcoal transition-colors duration-300"
                    >
                        Reserve Private Event
                    </button>
                </motion.div>
            </div>
        </section>
    );
}
